import {
  SignUpRequestExpanded,
  signUpCache,
} from "@faire/retailer-visitor-shared/features/SignUp/SignUpRequestData";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore/createContextStore";
import { useAllFieldsOfContextStore } from "@faire/web--source/ui/hooks/ContextStore/hooks";

const { useStore: useSignUpRequest, Provider: SignUpRequestProvider } =
  createContextStore<SignUpRequestExpanded>(signUpCache.get(), {
    name: "SignUpRequestStore",
  });

export const useFullSignUpRequest = () => {
  "use no memo";
  return useAllFieldsOfContextStore(useSignUpRequest);
};

export { useSignUpRequest, SignUpRequestProvider };
